import { Controller } from "@hotwired/stimulus";

export class HeroController extends Controller {
  static targets = ["navbar", "logoMask", "hero", "content", "scrollHint"];
  static values = { rootPath: String };

  connect() {
    this.onScroll();
    if (!this.hasNavbarTarget) return;
    if (!this.hasHeroTarget) {
      if (this.hasLogoMaskTarget) {
        this.logoMaskTarget.style.setProperty("--wipe-from-bottom", `100%`);
      }
      this.navbarTarget.style.setProperty("--wipe-from-bottom", `100%`);
      return;
    }

    this.onScroll = this.onScroll.bind(this);
    window.addEventListener("scroll", this.onScroll, { passive: true });
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll);
  }

  logoClick(event) {
    event.preventDefault();
    const href = event.currentTarget.href;

    if (this.isRootPath()) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      window.location.href = href;
    }
  }

  isRootPath() {
    const current = window.location.pathname.replace(/\/$/, "") || "/";
    const root = this.rootPathValue.replace(/\/$/, "") || "/";
    return current === root;
  }
  onScroll() {
    if (!this.hasHeroTarget) return;

    const heroRect = this.heroTarget.getBoundingClientRect();
    const boundary = heroRect.bottom;

    if (this.hasScrollHintTarget && -heroRect.top / heroRect.height >= 0.2) {
      this.scrollHintTarget.classList.add("img-scroll--hidden");
    }

    // Updating logo wipe
    if (this.hasLogoMaskTarget) {
      const logoRect = this.logoMaskTarget.getBoundingClientRect();
      const swept = (logoRect.bottom - boundary) / logoRect.height;
      const clamped = Math.min(1, Math.max(0, swept));

      this.logoMaskTarget.style.setProperty(
        "--wipe-from-bottom",
        `${clamped * 100}%`,
      );
    }

    // Updating navbar wipe
    const navbarRect = this.navbarTarget.getBoundingClientRect();
    const sweptNav = (navbarRect.bottom - boundary) / navbarRect.height;
    const clampedNav = Math.min(1, Math.max(0, sweptNav));

    this.navbarTarget.style.setProperty(
      "--wipe-from-bottom",
      `${clampedNav * 100}%`,
    );
  }
}
